import { TextField } from '@jisr-hr/ds'
import { CSSProperties, ReactNode } from 'react'
import { Field, FieldRenderProps } from 'react-final-form'

type TextInputFieldProps = {
  name: string
  testId?: string
  status?: string
  statusMessage?: string
  validate?: (value: string) => string | undefined
  size?: 'sm' | 'md' | 'lg'
  style?: CSSProperties
  className?: string
  iconTrailing?: React.ReactNode
  iconLeading?: React.ReactNode
  as?: string
  disabled?: boolean
  type?: 'text' | 'number' | 'email' | 'password' | 'date' | 'range' | 'url'
  placeholder?: string
  dropdownLeading?: ReactNode
  dropdownTrailing?: ReactNode
  id?: string
  actionButton?: JSX.Element
}

const NewTextInputField = ({
  name,
  validate,
  testId,
  style,
  size = 'sm',
  className,
  iconTrailing,
  iconLeading,
  as,
  disabled,
  type = 'text',
  placeholder,
  dropdownLeading,
  dropdownTrailing,
  id,
  ...props
}: TextInputFieldProps): JSX.Element => (
  <Field
    name={name}
    validate={validate}
  >
    {({ input, meta }: FieldRenderProps<any, HTMLElement>): JSX.Element => {
      return (
        <TextField
          style={style}
          {...props}
          {...input}
          type={type}
          destructive={meta.touched && !!meta.error}
          helperText={meta.touched && meta.error}
          onBlur={input.onBlur}
          size={size}
          testId={testId}
          className={className}
          iconTrailing={iconTrailing}
          iconLeading={iconLeading}
          as={as}
          disabled={disabled}
          placeholder={placeholder}
          dropdownLeading={dropdownLeading}
          dropdownTrailing={dropdownTrailing}
          id={id}
        />
      )
    }}
  </Field>
)

export default NewTextInputField
